<template>
  <div class="intro">
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
    <Button @click="onClick">Learn more</Button>
  </div>
</template>

<script lang="ts" setup>
import { posthog } from "posthog-js"
import { Button } from "~/components/base/button"
const title = "Welcome to Handda!"
const description = "We are working hard to release a new product soon."

const onClick = () => {
  posthog.capture("$clicked_intro_button", {
    $current_url: window.location.href
  })
}
</script>
